import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  textField: {
    '& fieldset': {
      display: 'none !important',
    },
  },
}));
